/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DmvsGadDocsEditCheckCreateRequest = {} | null | undefined;
export type DmvsGadDocsEditCheckCreateResponse = any;

export type DmvsGadDocsEditCheckCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/dmvs_gad_docs/{id}/edit_check/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_edit_check_create
 * tags:
 *   - dmvs_gad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsGadDocsEditCheckCreateOperation = ({
  id,
  ...rest
}: DmvsGadDocsEditCheckCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/dmvs_gad_docs/${id}/edit_check/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dmvs_gad_docs/{id}/edit_check/' };
  };

/**
 * POST /dmx-server/dmvs_gad_docs/{id}/edit_check/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_edit_check_create
 * tags:
 *   - dmvs_gad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsGadDocsEditCheckCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DmvsGadDocsEditCheckCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dmvsGadDocsEditCheckCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
